import { PROFILE_ERROR, GET_PROFILE, PROFILE_SUCCESS, EDIT_PROFILE, RESET_PROFILE_FLAG, CHANGE_AVARTAR_PROFILE } from "./actionTypes";

const initialState = {
    error: "",
    success: "",
    user: {}
};

const profile = (state = initialState, action) => {
    switch (action.type) {
        case GET_PROFILE:
            state = { 
                ...state 
            };
            break;
        case EDIT_PROFILE:
            state = { ...state };
            break;
        case PROFILE_SUCCESS:
            state = {
                ...state,
                success: action.payload.status,
                user: action.payload.data
            };
            break;
        case CHANGE_AVARTAR_PROFILE:
            state = {
                ...state,
                url_img: action.payload
            };
            break;
        case PROFILE_ERROR:
            state = {
                ...state,
                error: action.payload
            };
            break;
        case RESET_PROFILE_FLAG:
            state = {
                ...state,
                success: null
            };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default profile;
